// extracted by mini-css-extract-plugin
export default {"h1":"_3Eba-lrUAX6bHQ0jQ-SzJ3","h2":"VqURO1WwBF02cSGAgCBhn","h3":"_25lJ40FF3_nbp2UPZYdcGl","h4":"kimn3jMRb7nY5StCgzntk"};